import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { fetchDropdowns, prefillArrayFields } from './utils';
import FormFieldRenderer from './FormFieldRenderer';
import './DynamicForm.css';

const DynamicForm = ({ fields, apiUrl, successRedirect }) => {
  const [formData, setFormData] = useState({});
  const [dropdownData, setDropdownData] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDropdowns(fields, setDropdownData);
  }, [fields]);

  useEffect(() => {
    prefillArrayFields(fields, formData, setFormData);
  }, [fields]);

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    setFormData({ ...formData, [name]: type === 'number' ? parseInt(value, 10) : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(apiUrl, formData);
      alert("Entry created successfully!");
      navigate(successRedirect);
    } catch (error) {
      console.error("Submission Error:", error);
      alert("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dynamic-form">
      <h2 className="form-title">Create New Entry</h2>
      <form onSubmit={handleSubmit}>
        {fields.map((field, idx) => (
          <FormFieldRenderer
            key={idx}
            field={field}
            formData={formData}
            setFormData={setFormData}
            dropdownData={dropdownData}
          />
        ))}
        <div className="form-button-wrapper">
          <button className="submit-btn" disabled={loading}>
            {loading ? "Loading..." : "Create Entry"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default DynamicForm;
